import React from "react";
import "./App.scss";
import { BrowserRouter, Route, Routes, useLocation, Navigate } from "react-router-dom";

import LoadingPortal, { LoadingPage } from "util/component/Loading";
import LoadingModal from "util/component/Loading/loading";

import { withTranslation } from "react-i18next";
import "util/i18n";
import Header from "./header/Header.jsx";
import HeaderAdmin from "./header/Header_Admin.jsx";

import Main, { ErrorPage } from "pages";
import Login from "pages/Login";
import LoginDev from "pages/LoginDev";
import Logout from "pages/Logout";
import AuthRoute from "pages/AuthRoute";
import DocPreview from "pages/PCSGenerator/preview";
import ReviewCompare from "pages/ReviewCompare"

import AutoLogin from "pages/Login/AutoLogin";

import Admin from "pages/admin";

import { useSelector } from "react-redux";

import { Security, LoginCallback } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";

const oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_ISSUER,
    clientId: process.env.REACT_APP_CLIENTID,
    redirectUri: process.env.REACT_APP_REDIRECTURI,
    // scopes: ["openid"],
    pkce: true,
});

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // 다음 렌더링에서 폴백 UI가 보이도록 상태를 업데이트 합니다.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // 에러 리포팅 서비스에 에러를 기록할 수도 있습니다.
        console.error(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // 폴백 UI를 커스텀하여 렌더링할 수 있습니다.
            // return <Navigate replace to={"/error/404"} />
        }
        return this.props.children;
    }
}

function App() {

    const loadingSelector = useSelector((store) => store.loading);

    const restoreOriginalUri = (_oktaAuth, originalUri) => {
        window.location.replace(toRelativeUrl(originalUri || "/", window.location.origin));
    };

    return (
        <BrowserRouter>
            <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
                <div className="wrap">
                    <ErrorBoundary>
                        <Routes>
                            <Route exact path="/login" element={<><Header /><Login /></>} />
                            <Route exact path="/direct-login" element={<AutoLogin />} />
                            <Route exact path="/loginDevmode-with-superstart" element={<><Header /><LoginDev /></>} />
                            <Route path="/login/callback" element={<LoginCallback loadingElement={<LoadingPage />} />} />
                            <Route exact path="/logout" element={<Logout />} />
                            <Route path="/PCSGeneratorPreview" element={<><Header /><DocPreview /></>} />
                            <Route path="ReviewCompare" element={<><Header /><ReviewCompare /></>} />
                            <Route path="/maintenance" element={<><Header /><Maintenance /></>} />
                            <Route path="/error/:status" element={<><Header /><ErrorPage /></>} />
                            <Route path="/noauth" element={<><Header /><NoPermissions /></>} />
                            <Route path="/*" element={<AuthRoute />}>
                                <Route path="admin/*" element={<><HeaderAdmin /><Admin /></>} />
                                <Route exact path="*" element={<><Header /><Main /></>} />
                            </Route>
                        </Routes>
                    </ErrorBoundary>
                </div>
                <div id="app-version"><small>{process.env.REACT_APP_VERSION}</small> </div>
                {loadingSelector && (
                    <LoadingPortal>
                        <LoadingModal />
                    </LoadingPortal>
                )}
            </Security>
        </BrowserRouter>
    );
}

const NoPermissions = (props, ref) => {

    return (
        <div className={"bpl-container text-center"}>
            <h2>Access Denied</h2>
            <i>
                You don't have permission to access this site.
                <br />
                Please contact BPL Admin.
            </i>
        </div>
    );
};

const Maintenance = () => {
    const { state } = useLocation();
    return (
        <section className={"maintenance"}>
            <div>
                <h1>Maintenance</h1>
                <h3 style={{ fontWeight: "normal" }}>Until {state.description} KST</h3>
            </div>
        </section>
    );
};

export default withTranslation()(App);
